import React from "react";
import {css, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {flex, mb, mr} from "@pg-design/helpers-css";
import {BrandLaurelIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

interface IProps {
    showOnMobile: boolean;
}

export const AwardedPlaceIndicator = (props: IProps) => {
    const theme = useTheme();
    const {isMobile} = useUserDevice();

    return (
        <PlaceIndicator showOnMobile={props.showOnMobile}>
            {isMobile ? (
                <BrandLaurelIcon css={mr(2)} size="3.2" />
            ) : (
                <BrandLaurelIcon css={mb(2)} size="7.2" wrapperColor={theme.colors.primary} wrapperSize="7.2" />
            )}

            <Text as="span" variant={props.showOnMobile ? "body_copy_1" : "headline_6"}>
                Wyróżnienie
            </Text>
        </PlaceIndicator>
    );
};

const PlaceIndicator = styled.div<{showOnMobile?: boolean}>`
    display: none;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        ${flex("center")};
        flex-direction: column;
        ${mr(4)};
    }

    ${(props) =>
        props.showOnMobile &&
        css`
            ${flex("center")};

            @media (min-width: ${props.theme.breakpoints.md}) {
                display: none;
            }
        `}
`;
